jQuery("document").ready(function($) {
  var $product = $("#product-select");
  if ($product.length) {
    var select = $product.select2();

    var searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('product')) {
      select.val(searchParams.get('product'));
      select.trigger('change');
    }
  }

  if (window.location.search.includes("variant")) {
    $(".product-detail .product-detail__thumbnails-wrapper").hide();
  }

  if ($(".product-detail .product-detail__thumbnails-wrapper").length) {
    var thumbnails = $(".product-detail__thumbnails")[0];
    if (thumbnails.scrollWidth <= thumbnails.clientWidth) {
      // Hide the thumbnail gradient if thumbnails aren't overflowing
      $(".product-detail__thumbnails-gradient").hide();
    }

    document.addEventListener('change', function() {
      if (window.location.search.includes("variant")) {
        $(".product-detail .product-detail__thumbnails-wrapper").hide();
      }
    });
  }

  if ($(".hulkapps-volumes").length) {
    var observer = new MutationObserver(function(records, observer) {
      $(".product-detail__app-container-title").show();
      observer.disconnect();
    });

    observer.observe($(".hulkapps-volumes")[0], {
      childList: true,
      subtree: true
    });
  }

  var $gallery = $(".gallery__button");
  if ($gallery.length) {
    var lg = lightGallery($gallery[0], {
      plugins: [lgThumbnail],
      dynamic: true,
      dynamicEl: $gallery.data('images').split(',').map(function(image) {
        return {
          src: image,
          thumb: image
        }
      })
    });

    $gallery.on("click", function() {
      lg.openGallery();
    })
  }

  function adjust_images_with_overlay() {
    const images_with_overlays = $("[data-section-type='full-width-image']");
    if (images_with_overlays.length) {
      images_with_overlays.each(function() {
        const overlay = $(this).find(".overlay");
        const image = $(this).find(".rimage-background");

        if (overlay.outerHeight() > image.outerHeight()) {
          $(image).css('min-height', `${overlay.outerHeight() + 30}px`)
        }
      });
    }
  }

  adjust_images_with_overlay();
  window.addEventListener('resize', adjust_images_with_overlay);

  $("input[name='country-search']").on("input", function (e) {
    const value = e.target.value.toLowerCase();

    $("[data-disclosure-country] .disclosure-list__item").each(function() {
      if ($(this).attr('data-country').toLowerCase().includes(value)) {
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
    });
  })
});